const PASSWORD_PATTERN_ERROR = 'Password must be a minimum of 8 characters, contain 1 number, 1 letter and 1 of the following special characters: !@#$%^&*';
const PASSWORD_HINT = `
    <p class="tooltip_message">
        <span class="title--small tooltip_title title">
            <span class="icon--remove visible-xs"></span>
            Your password must:
        </span>
        <ul class="secure-user-account-form__hints">
            <li>Be at least 8 characters in length</li>
            <li>Include at least 1 letter</li>
            <li>Include at least 1 number</li>
            <li>Include at least 1 of the following special characters: !@#$%^&*</li>
        </ul>
    </p>
`;

function PasswordValidationService($q, settingsService) {
    this.$q = $q;
    this.settingsService = settingsService;
    this.passwordPatternError = PASSWORD_PATTERN_ERROR;
    this.passwordHint = PASSWORD_HINT;
}

PasswordValidationService.prototype.getPattern = function () {
    const spaInitialisationSettings = this.settingsService.getPageModelData('SpaInitialisationSettings') || [];
    const passwordMatchExpressions = spaInitialisationSettings.find(
        setting => setting.Group === 'Registration' && setting.Name === 'PasswordMatchExpressions'
    );

    return passwordMatchExpressions && passwordMatchExpressions.Value
        ? passwordMatchExpressions.Value.substring(passwordMatchExpressions.Value.indexOf('^'))
        : undefined;
};

module.exports = PasswordValidationService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/password-validation/password-validation-service.js
 **/